import { useSelector } from 'react-redux';
import { selectEventsData } from '../events/eventsSlice';
import useImagesSrc from '../../helper/useImagesSrc';
import { usePreloadImages } from '../../helper/usePreloadImages';
import { useEffect } from 'react';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import UIButton from '../../UI/UIButton';

const ClientsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	@media only screen and (max-width: 450px) {
		margin-top: 50px;
		justify-content: flex-start;
	}
	@media only screen and (max-width: 450px) and (max-height: 600px) {
		margin-top: 5px;
	}
`;

const BillionsPeopleText = styled.div`
	color: #f58a3c;
	font-size: 28px;
	font-weight: 800;
	line-height: 36px;
	letter-spacing: -0.14px;
`;

const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 16px;
	background: #fef7f1;
	padding: 19px 16px 16px;
`;

const AlreadyUseText = styled.div`
	font-size: 14px;
	font-weight: 400;
	letter-spacing: -0.24px;
	color: #323232;
	margin-top: 5px;
`;

const ReviewWrapper = styled.div`
	margin-top: 16px;
	border-radius: 12px;
	background: #fff;
	box-shadow: 4px 6px 20px 0px rgba(0, 0, 0, 0.12);
	padding: 19px 16px 16px;
`;

const ReviewText = styled.p`
	text-align: center;
	font-size: 14px;
	font-weight: 700;
	line-height: 21px;
	letter-spacing: -0.24px;
	margin-top: 10px;
	margin-bottom: 16px;
	color: #323232;
`;

const QuotesImg = styled.img`
	width: 26px;
	height: 24px;
`;

const TechCrunchOrangeImg = styled.img`
	width: 120px;
	height: 16px;
`;

const LogoWrapper = styled.div`
	margin-top: 32px;
	@media only screen and (max-width: 450px) and (max-height: 600px) {
		margin-top: 10px;
	}
`;

const AboutUsText = styled.div`
	color: #121212;
	font-size: 16px;
	font-weight: 800;
	line-height: 21px;
	letter-spacing: -0.08px;
	text-align: center;
`;

const CompanyLogoWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: 20px;
	width: 100%;
	margin-top: 15px;
`;

const companyLogos = [
	{
		id: 1,
		imgPath: '../assets/massmedia/spiegel-online.png',
		imgWidth: 62,
		imgHeight: 39,
	},
	{
		id: 2,
		imgPath: '../assets/massmedia/tech-crunch.png',
		imgWidth: 93,
		imgHeight: 12,
	},
	{
		id: 3,
		imgPath: '../assets/massmedia/die-welt.png',
		imgWidth: 84,
		imgHeight: 14,
	},
	{
		id: 4,
		imgPath: '../assets/massmedia/wired.png',
		imgWidth: 76,
		imgHeight: 16,
	},
	{
		id: 5,
		imgPath: '../assets/massmedia/bild.png',
		imgWidth: 40,
		imgHeight: 44,
	},
	{
		id: 6,
		imgPath: '../assets/massmedia/rtl.png',
		imgWidth: 89,
		imgHeight: 17,
	},
];

const LogoItem = styled.img`
	max-width: 100%;
	height: ${({ imgHeight }) => imgHeight && `${imgHeight}px`};
	width: ${({ imgWidth }) => imgWidth && `${imgWidth}px`};
`;

const AboutUs = ({ history }) => {
	const { t } = useTranslation();
	const eventsData = useSelector(selectEventsData);
	const { imagesSources } = useImagesSrc();
	usePreloadImages(imagesSources['choose-target']);

	useEffect(
		() => sendAnalyticsEvents(EVENTS.onboardingMassmediaShown, eventsData),
		[eventsData]
	);

	const onContinueClick = () => {
		sendAnalyticsEvents(EVENTS.onboardingMassmediaSubmitted, eventsData);
		history.push('/choose-target');
	};

	return (
		<ClientsWrapper>
			<TextWrapper>
				<BillionsPeopleText>{t('billions_people')}</BillionsPeopleText>
				<AlreadyUseText>{t('already_use')}</AlreadyUseText>
				<ReviewWrapper>
					<QuotesImg src="../assets/massmedia/quote.png" alt="Quotes" />
					<ReviewText>{t('thanks_review')}</ReviewText>
					<TechCrunchOrangeImg
						src="../assets/massmedia/tc-logo.png"
						alt="TechCrunch logo"
					/>
				</ReviewWrapper>
			</TextWrapper>
			<LogoWrapper>
				<AboutUsText>{t('write_about_us')}</AboutUsText>
				<CompanyLogoWrapper>
					{companyLogos.map((logo, index) => (
						<LogoItem
							key={logo.id || index}
							src={logo.imgPath}
							imgWidth={logo.imgWidth}
							imgHeight={logo.imgHeight}
							alt={`${logo.id} logo`}
						/>
					))}
				</CompanyLogoWrapper>
			</LogoWrapper>
			<UIButton
				onClick={onContinueClick}
				customMargin={'30px 0 0'}
				bottomPosition="16px"
				customBeforeBg="none"
			/>
		</ClientsWrapper>
	);
};

export default AboutUs;
